export default __webpack_public_path__ + "static/speaker4-99b3f11c3545a9323f6042f49891c61a.jpg";